import { InjectionToken, Signal } from '@angular/core';
import { ClientEntity, CompanyEntity } from '@domain';
import { DocumentEntity } from 'src/app/domain/entities/document.entity';

/**
 * Contexto de valores reais para validar tags na edição do documento.
 * Preenchido em edit.page via EditDataService (document, client) e CompanyController (company).
 */
export interface DataTagContext {
    document?: DocumentEntity | null;
    client?: ClientEntity | null;
    company?: CompanyEntity | null;
}

export const DATA_TAG_CONTEXT = new InjectionToken<Signal<DataTagContext | null>>(
    'DATA_TAG_CONTEXT'
);
